import { IItemsStyle } from "../../../../documaker/domain/format/objects";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface IItemsStylePropertyEditable {
  itemsStyle(): IPropertyEditable<IItemsStyle>;
}

export function instanceOfIItemsStylePropertyEditable(instance: any): instance is IItemsStylePropertyEditable {
  return instance
      && instance.itemsStyle
      && instanceOfIPropertyEditable<IItemsStyle>(instance.itemsStyle());
}
